import React, { memo } from 'react';

// styles
import { Info } from './StockInfo.styles';

interface Props {
  isOutOfStock: boolean;
  stockRemaining?: number | boolean;
  className?: string;
}

const SOLD_OUT = 'sold out';
const STOCK_LEFT_TEXT = 'left';

function StockInfo({ isOutOfStock, stockRemaining, className }: Props) {
  if (isOutOfStock) {
    return (
      <Info
        className={className}
        data-at="size-stock-soldout"
        isOutOfStock={isOutOfStock}
      >
        {SOLD_OUT}
      </Info>
    );
  }

  if (stockRemaining) {
    return (
      <Info className={className} data-at="size-stock-left">
        {stockRemaining}&nbsp;{STOCK_LEFT_TEXT}
      </Info>
    );
  }

  return null;
}

export default memo(StockInfo);
